import { useCallback } from 'react';
import { PrimaryDataSet } from '../../types';
import { useProjectData } from '../stores/hooks/useProjectData';
import { excludeRows } from '../utils/row-exclusion-manager';
import logger from '../utils/logger';

/**
 * 行の除外機能を提供するカスタムフック
 * 
 * DataTableなどのコンポーネントから使用できる行の除外機能を提供
 */
export const useRowExclusion = (dataset: PrimaryDataSet | undefined) => {
  const { updateDataset } = useProjectData();
  
  // 行を除外する
  const handleExcludeRows = useCallback((rowIndices: readonly number[], comment?: string) => {
    if (!dataset) {
      logger.warn('[useRowExclusion] Cannot exclude rows: no dataset');
      return;
    }
    
    if (dataset.type !== 'primary') {
      logger.warn('[useRowExclusion] Cannot exclude rows: not a primary dataset');
      return;
    }
    
    logger.info('[useRowExclusion] Excluding rows', { 
      datasetId: dataset.id, 
      rowCount: rowIndices.length,
      comment 
    });
    
    // 除外処理を実行
    excludeRows(dataset, rowIndices, comment);
    
    // ストアを更新（新しいオブジェクト参照を作成して再レンダリングをトリガー）
    updateDataset(dataset.id, () => ({ ...dataset }));
  }, [dataset, updateDataset]);
  
  // 除外された行のRowNumber一覧を取得
  const excludedRowNumbers = dataset?.type === 'primary' && dataset.exclusions?.excludedRows
    ? Object.keys(dataset.exclusions.excludedRows).map(Number)
    : [];
  
  return {
    handleExcludeRows,
    excludedRowNumbers,
    isExclusionSupported: dataset?.type === 'primary'
  };
};